export default __webpack_public_path__ + "static/media/appStore.4bc7233f.png";